// @flow
import * as React from 'react'
import ApiService from '../../actions/apiService'
import {Row, Col} from 'antd'
import { connect } from 'react-redux';
import moment from 'moment'
import ProfitChart from './ProfitChart'
import EquityChart from './EquityChart'
import {numberFormatter} from '../../utils/common'
import {StyledContent, StyledCard, TradeBoxDiv} from './style'
import ComponentContainer from '../container-component'

class ChartDashboard extends React.Component {
  
  state = {
    yearData: [],
    monthData: [],
    symbolData: [],
    strategyData: [],
    isLoading: false,
    performanceData: {},
  }
  
  componentWillMount() {
    this.getData(this.props.account);
  }
  
  componentWillReceiveProps(nextProps) {
    if (this.props.account !== nextProps.account) {
      this.getData(nextProps.account);
    }
  }
  
  getData = async (account) => {
    this.setState({
      isLoading: true,
    })
    const data = {
      Account: account
    };
    const equity = await ApiService.getProfitLoss('closedcumulativeprofitloss', data);
    const year = await ApiService.getProfitLoss('profitlossbyyear', data);
    const month = await ApiService.getProfitLoss('profitlossbymonthly', data);
    const symbol = await ApiService.getProfitLoss('profitlosspersymbol', data);
    const strategy = await ApiService.getProfitLoss('profitlossperstrategy', data);
    const performance = await ApiService.postMethod('/account/performance', data);
    let yearData = [];
    let monthData = [];
    let symbolData = [];
    let strategyData = [];
    let equityData = [];
    let performanceData = {};
    if (year) {
      yearData = year.map(item=> ({
        y: moment(item.profitLossDate).format('YYYY'),
        x: item.profitLoss,
      }))
    }
    if (month) {
      monthData = month.sort((a, b) => moment(a.profitLossDate) - moment(b.profitLossDate)).map(item=> ({
        y: moment(item.profitLossDate).format('MMM YY'),
        x: item.profitLoss,
      }))
    }
    if (symbol) {
      symbolData = symbol.map(item=> ({
        y: item.symbol,
        x: item.profitLoss,
      }))
    }
    if (strategy) {
      strategyData = strategy.map(item=> ({
        y: item.strategyGroupName,
        x: item.profitLoss,
      }))
    }
    if (equity) {
      equityData = equity.map(item=> ({
        y: moment(item.tradeDate).format('YYYY-MM-DD'),
        x: item.profitLoss,
      }))
    }
    if (performance) {
      performanceData = performance;
    }
    this.setState({
      yearData,
      monthData,
      symbolData,
      strategyData,
      equityData,
      performanceData,
      isLoading: false,
    })
  }
  
  render() {
    const { yearData, monthData, symbolData, strategyData, equityData, isLoading, performanceData } = this.state;
    return (
      <StyledContent>
        
        {
          isLoading &&
            <ComponentContainer
            title={'Loading Trade Data'}
            loading={isLoading}
            resetData={() => this.getData(this.props.account)}>
            <h1>Loading Trade Data</h1>
          </ComponentContainer>
        }
        {
          !isLoading &&
          <StyledCard title="Trade Data">
            <Row>
              <Col sm={6}>
                <TradeBoxDiv className="trade-box">
                  <h3>Total Value</h3>
                  <div>
                    <b>{performanceData.accountValue_Formated}</b>
                    <span className={ performanceData.pL_Total > 0 ? 'green' : 'red'}>{performanceData.pL_Total_Formated}</span>
                  </div>
                </TradeBoxDiv>
              </Col>
              <Col sm={6}>
                <TradeBoxDiv className="trade-box">
                  <h3>Profit Loss</h3>
                  <div>
                    <b>{performanceData.pL_Total_Formated}</b>
                    <span className={ performanceData.pL_Open > 0 ? 'green' : 'red'}>{numberFormatter(performanceData.pL_Open)} open</span>
                    <span className={ performanceData.pL_Closed > 0 ? 'green' : 'red'}>{numberFormatter(performanceData.pL_Closed)} closed</span>
                  </div>
                </TradeBoxDiv>
              </Col>
              <Col sm={6}>
                <TradeBoxDiv className="trade-box">
                  <h3>Win Ratio</h3>
                  <div>
                    <b>{((performanceData.totalWinningTrades/(performanceData.totalNumberOfTrades || 1)) || 0).toFixed(2)}%</b>
                    <span className="green">{performanceData.totalWinningTrades} W</span>
                    <span className="red">{performanceData.totalLossingTrades} L</span>
                  </div>
                </TradeBoxDiv>
              </Col>
              <Col sm={6}>
                <TradeBoxDiv className="trade-box">
                  <h3>Total Trades</h3>
                  <div>
                    <b>{numberFormatter(performanceData.totalNumberOfTrades)}</b>
                    <span>{numberFormatter(performanceData.totalNumberOpenTrades)} O</span>
                    <span>{numberFormatter(performanceData.totalNumberClosedTrades)} C</span>
                  </div>
                </TradeBoxDiv>
              </Col>
              <Col sm={6}>
                <TradeBoxDiv className="trade-box">
                  <h3>Total Commission</h3>
                  <div>
                    <b>{numberFormatter(performanceData.totalCommission)}</b>
                  </div>
                </TradeBoxDiv>
              </Col>
              <Col sm={6}>
                <TradeBoxDiv className="trade-box">
                  <h3>Average Winning Trade</h3>
                  <div>
                    <b>{numberFormatter(performanceData.averageWinningTrade)}</b>
                    <span>{numberFormatter(performanceData.averageHoldTimeWinning)} Avg Hold</span>
                  </div>
                </TradeBoxDiv>
              </Col>
              <Col sm={6}>
                <TradeBoxDiv className="trade-box">
                  <h3>Average Losing Trade</h3>
                  <div>
                    <b>{numberFormatter(performanceData.averageLossingTrade)}</b>
                    <span>{numberFormatter(performanceData.averageHoldTimeLossing)} Avg Hold</span>
                  </div>
                </TradeBoxDiv>
              </Col>
            </Row>
            <Row>
              <Col sm={23}>
                <EquityChart height={600} data={equityData} title="Equity Curve" />
              </Col>
            </Row>
            <Row>
              <Col sm={10}>
                <ProfitChart height={500} data={yearData} title="Profit Loss By Year" />
              </Col>
              <Col sm={4} />
              <Col sm={10}>
                <ProfitChart height={500} data={monthData} title="Profit Loss By Month" />
              </Col>
            </Row>
            <Row>
              <Col sm={10}>
                <ProfitChart height={1200} data={symbolData} title="Profit Loss By Symbol"/>
              </Col>
              <Col sm={4} />
              <Col sm={10}>
                <ProfitChart height={1000} data={strategyData} title="Profit Loss By Strategy"/>
              </Col>
            </Row>
          </StyledCard>
        }
      </StyledContent>
    )
  }
}

const mapStateToProps = (state) => ({
  account: state.account.selectedAccount
})

export default connect(mapStateToProps, null)(ChartDashboard)



// WEBPACK FOOTER //
// ./src/components/ChartDashboard/index.js